<template>
	<v-slide-y-reverse-transition>
		<v-sheet
			v-if="usePrices"
			class="balance-banner px-4 py-2 d-flex align-center justify-space-between"
			color="white"
			elevation="0"
		>
			<div class="text-body-2 font-weight-bold">{{$t('current-balance')}}</div>
			<div class="text-subtitle-1 font-weight-bold primary--text">
				{{$options.filters.formatNumber(balance || 0, 3)}}
			</div>
		</v-sheet>
	</v-slide-y-reverse-transition>
</template>

<script>
import { mapState } from 'vuex'
import { usePrices } from '@/configs/general.configs'

export default {
	name: 'BalanceBanner',

	data() {
		return {
			usePrices,
		}
	},

	computed: {
		...mapState({
			balance: state => state.profile.balance,
		}),
	},
}
</script>

<style scoped>
.balance-banner {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 65px;
	z-index: 6;
	/* border-top: 1px solid rgba(0, 0, 0, 0.08);   */
}
</style>